module.exports = __webpack_public_path__ + "img/hr-heat-pipe-corner-down-right-3.d5bdc975.png";